import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import type { BaseError } from '@utils/types/shared/base.ts';
import type { StartOAuthResponse } from '@utils/types/connections/connection.ts';

interface ReconnectArgs {
  connectionId: string;
  redirect_uri: string;
}

async function reconnectConnection({
  connectionId,
  redirect_uri
}: ReconnectArgs): Promise<StartOAuthResponse> {
  const { data } = await Axios.post<StartOAuthResponse>(
    POST_URL(connectionId).reconnectConnection,
    { redirect_uri }
  );
  return data;
}

export function useReconnectConnection() {
  return useMutation<StartOAuthResponse, AxiosError<BaseError>, ReconnectArgs>(
    reconnectConnection,
    { useErrorBoundary: false }
  );
}
